import angular from 'angular';
import { ReadOnlyPromptItemComponent } from './ReadOnlyPromptItem/ReadOnlyPromptItem.component';
import { InstructionsListComponent } from './instructionsList/instructionsList.component';
import { GenerateInstructionFormComponent } from './generateInstructionForm/generateInstructionForm.component';
import { GeneratingInstructionsComponent } from './generatingInstructions/generatingInstructions.component';
import { OptimizedPromptResultComponent } from './optimizedPromptResult/optimizedPromptResult.component';
import { InstructionErrorComponent } from './instructionError/instructionError.component';
function generateInstructionMarkup(line) {
    const trimmedLine = line.trim();
    const content = trimmedLine.startsWith('#') ? `<strong>${trimmedLine}</strong>` : line;
    return `<bds-typo disabled="disabled" variant="fs-14">${content}</bds-typo>`;
}
export const instructionComponents = angular.module('instructionComponents', [])
    .component('readOnlyPromptItem', ReadOnlyPromptItemComponent)
    .component('instructionsList', InstructionsListComponent)
    .component('generateInstructionForm', GenerateInstructionFormComponent)
    .component('generatingInstructions', GeneratingInstructionsComponent)
    .component('optimizedPromptResult', OptimizedPromptResultComponent)
    .component('instructionError', InstructionErrorComponent)
    .filter('newline', ['$sce', ($sce) => (text) => {
        if (!text)
            return text;
        const html = text.split('\n')
            .map(generateInstructionMarkup).join('');
        return $sce.trustAsHtml(html);
    }])
    .name;
